import { ROLE } from 'shared/types';
export function getBoardTypeName(type) {
    switch (type) {
        case 'Board': return '게시판형';
        case 'Gallery': return '갤러리형';
        default: return type;
    }
}
export function getRoleName(role) {
    switch (role) {
        case ROLE.ADMINISTRATOR: return '최고관리자';
        case ROLE.MANAGER: return '매니저';
        case ROLE.MEMBER: return '회원';
        case ROLE.AWAITER: return '가입대기자';
        case ROLE.BANNED: return '정지회원';
        case ROLE.NONMEMBER: return '비회원';
        default: return role;
    }
}
